import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-137de2fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body p-9" }
const _hoisted_5 = { class: "row mb-6" }
const _hoisted_6 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle ms-1 fs-6" }, null, -1))
const _hoisted_8 = { class: "col-lg-8" }
const _hoisted_9 = { class: "symbol" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-icon btn-circle btn-active-color-info w-25px h-25px bg-body shadow position-absolute top-0 start-100 translate-middle",
  style: {"z-index":"1"}
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-fill fs-7" })
], -1))
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "form-text mt-5" }
const _hoisted_13 = { class: "row mb-6 editor-container" }
const _hoisted_14 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_15 = { class: "col-lg-8" }
const _hoisted_16 = { class: "row mb-6" }
const _hoisted_17 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_18 = { class: "col-lg-8" }
const _hoisted_19 = { class: "d-flex align-items-center gap-3 flex-wrap" }
const _hoisted_20 = {
  key: 0,
  class: "d-flex align-items-center gap-3"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-pdf-fill text-danger fs-2 me-2" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1))
const _hoisted_23 = { class: "row mb-6" }
const _hoisted_24 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_25 = { class: "col-lg-8" }
const _hoisted_26 = { class: "d-flex align-items-center gap-3 flex-wrap" }
const _hoisted_27 = {
  key: 0,
  class: "d-flex align-items-center gap-3"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-pdf-fill text-danger fs-2 me-2" }, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1))
const _hoisted_30 = { class: "card mb-5 mb-xl-10" }
const _hoisted_31 = { class: "card-header" }
const _hoisted_32 = { class: "card-title" }
const _hoisted_33 = { class: "card-body p-9" }
const _hoisted_34 = { class: "d-flex align-items-center gap-3" }
const _hoisted_35 = { class: "d-flex flex-column gap-1" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-up" }, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-down" }, null, -1))
const _hoisted_38 = { class: "flex-grow-1" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1))
const _hoisted_40 = { class: "d-flex justify-content-end mb-5" }
const _hoisted_41 = { class: "d-flex align-items-center gap-3" }
const _hoisted_42 = { class: "d-flex flex-column gap-1" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-up" }, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-down" }, null, -1))
const _hoisted_45 = { class: "flex-grow-1" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1))
const _hoisted_47 = { class: "d-flex justify-content-end mb-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_Page = _resolveComponent("Page")!

  return (_openBlock(), _createBlock(_component_Page, null, {
    actions: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _ctx.handleSave,
        loading: _ctx.guardando
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("page.acciones.guardar")), 1)
        ]),
        _: 1
      }, 8, ["onClick", "loading"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t("page.website.home.configuracionInicio")), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, [
              _createTextVNode(_toDisplayString(_ctx.$t("page.website.home.imagenCabecera")) + " ", 1),
              _createVNode(_component_el_tooltip, {
                content: _ctx.$t('page.website.home.imagenCabeceraInfo'),
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["content"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_upload, {
                  class: "avatar-uploader",
                  "show-file-list": false,
                  "before-upload": _ctx.beforeHeaderUpload
                }, {
                  trigger: _withCtx(() => [
                    _hoisted_10
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _ctx.headerImageUrl,
                      class: "img-thumbnail shadow w-200px"
                    }, null, 8, _hoisted_11)
                  ]),
                  _: 1
                }, 8, ["before-upload"])
              ]),
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("formularios.curso.imagen.filesAllowed")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("page.website.home.contenidoPrincipal")), 1),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_QuillEditor, {
                theme: "snow",
                content: _ctx.introHtml,
                "onUpdate:content": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.introHtml) = $event)),
                contentType: "html"
              }, null, 8, ["content"])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("page.website.home.pdfResumen")), 1),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_el_upload, {
                  action: "#",
                  "auto-upload": false,
                  "show-file-list": false,
                  "on-change": _ctx.onResumenChange
                }, {
                  trigger: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("page.actions.subir")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["on-change"]),
                (_ctx.pdfResumenUrl)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.openPdf(_ctx.pdfResumenUrl, _ctx.pdfResumenName)), ["prevent"])),
                        class: "text-primary fw-bold d-flex align-items-center"
                      }, [
                        _hoisted_21,
                        _createTextVNode(" " + _toDisplayString(_ctx.pdfResumenName || _ctx.$t("page.website.home.verPdfResumen")), 1)
                      ]),
                      _createVNode(_component_el_button, {
                        size: "small",
                        circle: "",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.removePdf('resumen')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_22
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("page.website.home.pdfPrograma")), 1),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_el_upload, {
                  action: "#",
                  "auto-upload": false,
                  "show-file-list": false,
                  "on-change": _ctx.onProgramaChange
                }, {
                  trigger: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("page.actions.subir")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["on-change"]),
                (_ctx.pdfProgramaUrl)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.openPdf(_ctx.pdfProgramaUrl, _ctx.pdfProgramaName)), ["prevent"])),
                        class: "text-primary fw-bold d-flex align-items-center"
                      }, [
                        _hoisted_28,
                        _createTextVNode(" " + _toDisplayString(_ctx.pdfProgramaName || _ctx.$t("page.website.home.verPdfPrograma")), 1)
                      ]),
                      _createVNode(_component_el_button, {
                        size: "small",
                        circle: "",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.removePdf('programa')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_29
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("h3", _hoisted_32, _toDisplayString(_ctx.$t("page.website.home.faqs.title")), 1)
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createVNode(_component_el_tabs, { type: "border-card" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tab_pane, {
                label: _ctx.$t('page.website.home.sobreCursos')
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqsCursos, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: 'cursos-' + index,
                      class: "faq-card-wrapper mb-4"
                    }, [
                      _createVNode(_component_el_card, { shadow: "hover" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              _createVNode(_component_el_button, {
                                disabled: index === 0,
                                onClick: ($event: any) => (_ctx.move(index, -1, 'cursos')),
                                size: "small",
                                circle: ""
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_36
                                ]),
                                _: 2
                              }, 1032, ["disabled", "onClick"]),
                              _createVNode(_component_el_button, {
                                disabled: index === _ctx.faqsCursos.length - 1,
                                onClick: ($event: any) => (_ctx.move(index, 1, 'cursos')),
                                size: "small",
                                circle: "",
                                class: "mx-0"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_37
                                ]),
                                _: 2
                              }, 1032, ["disabled", "onClick"])
                            ]),
                            _createElementVNode("div", _hoisted_38, [
                              _createVNode(_component_el_input, {
                                modelValue: item.pregunta,
                                "onUpdate:modelValue": ($event: any) => ((item.pregunta) = $event),
                                placeholder: _ctx.$t('page.website.home.faqs.preguntaCursos'),
                                class: "mb-2"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]),
                              _createVNode(_component_QuillEditor, {
                                theme: "snow",
                                content: item.respuesta,
                                "onUpdate:content": ($event: any) => ((item.respuesta) = $event),
                                contentType: "html"
                              }, null, 8, ["content", "onUpdate:content"])
                            ]),
                            _createVNode(_component_el_popconfirm, {
                              title: _ctx.$t('page.website.home.faqs.deleteConfirm'),
                              onConfirm: ($event: any) => (_ctx.removeItem(index, 'cursos'))
                            }, {
                              reference: _withCtx(() => [
                                _createVNode(_component_el_button, {
                                  plain: "",
                                  circle: ""
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_39
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["title", "onConfirm"])
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addItem('cursos')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("page.website.home.faqs.add")), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_tab_pane, {
                label: _ctx.$t('page.website.home.sobreIAM')
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqsIam, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: 'iam-' + index,
                      class: "faq-card-wrapper mb-4 color-iam"
                    }, [
                      _createVNode(_component_el_card, { shadow: "hover" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("div", _hoisted_42, [
                              _createVNode(_component_el_button, {
                                disabled: index === 0,
                                onClick: ($event: any) => (_ctx.move(index, -1, 'iam')),
                                size: "small",
                                circle: ""
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_43
                                ]),
                                _: 2
                              }, 1032, ["disabled", "onClick"]),
                              _createVNode(_component_el_button, {
                                disabled: index === _ctx.faqsIam.length - 1,
                                onClick: ($event: any) => (_ctx.move(index, 1, 'iam')),
                                size: "small",
                                circle: "",
                                class: "mx-0"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_44
                                ]),
                                _: 2
                              }, 1032, ["disabled", "onClick"])
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                              _createVNode(_component_el_input, {
                                modelValue: item.pregunta,
                                "onUpdate:modelValue": ($event: any) => ((item.pregunta) = $event),
                                placeholder: _ctx.$t('page.website.home.faqs.preguntaIAM'),
                                class: "mb-2"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]),
                              _createVNode(_component_QuillEditor, {
                                theme: "snow",
                                content: item.respuesta,
                                "onUpdate:content": ($event: any) => ((item.respuesta) = $event),
                                contentType: "html"
                              }, null, 8, ["content", "onUpdate:content"])
                            ]),
                            _createVNode(_component_el_popconfirm, {
                              title: _ctx.$t('page.website.home.faqs.deleteConfirm'),
                              onConfirm: ($event: any) => (_ctx.removeItem(index, 'iam'))
                            }, {
                              reference: _withCtx(() => [
                                _createVNode(_component_el_button, {
                                  plain: "",
                                  circle: ""
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_46
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["title", "onConfirm"])
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_47, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addItem('iam')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("page.website.home.faqs.add")), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}